export default __webpack_public_path__ + "static/0030-d0023a696aebd0fd95675273d9f6a4bc.png";